/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_CostInputs */

const en_sort_cost = /** @type {(inputs: Sort_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheapest`)
};

const de_sort_cost = /** @type {(inputs: Sort_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günstigste`)
};

/**
* | output |
* | --- |
* | "Cheapest" |
*
* @param {Sort_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_cost = /** @type {((inputs?: Sort_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_cost(inputs)
	return en_sort_cost(inputs)
});